module.exports = __webpack_public_path__ + "static/media/marketplace-aws-icon.53ccea7c.svg";